/**
 * De winkelwagen-URL mét taalprefix. Op /en/ en /fr/ is dat /en/cart en /fr/cart.
 * theme.liquid vult window.routes; de terugval is er voor als dat blok ooit
 * later laadt. Hardgecodeerd '/cart' gooide de bezoeker terug naar het
 * Nederlands, ook als hij van een /en/-productpagina kwam.
 */
function nlfCartUrl() {
  return (window.routes && window.routes.cart_url) || '/cart';
}

/**
 * NeverLeafs PDP, JavaScript
 * Variant switching, AJAX cart, sticky bar, FAQ, gallery, cross-sell
 * Portal Design System
 */

(function () {
  'use strict';

  /* ============================
     UTILS
     ============================ */

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + euros;
  }

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  /* ============================
     GALLERY
     ============================ */

  var galleryImages = [];
  var galleryIndex = 0;
  var galleryLaadVerzoek = 0;
  var preloadedImages = {};

  function preloadImage(src) {
    if (preloadedImages[src]) return preloadedImages[src];
    var p = new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () { resolve(src); };
      img.onerror = function () { resolve(src); };
      img.src = src;
    });
    preloadedImages[src] = p;
    return p;
  }

  function initGallery() {
    var thumbs = document.querySelectorAll('.nl-gallery__thumb');
    var mainImg = document.getElementById('nl-gallery-img');
    var prevBtn = document.getElementById('nl-gallery-prev');
    var nextBtn = document.getElementById('nl-gallery-next');

    // Met foto's per variant kan een reeks later pas thumbs krijgen, dus dan niet afhaken
    if (!mainImg || (thumbs.length === 0 && !fotoData)) return;

    thumbs.forEach(registreerThumb);

    // Preload gallery images in background, video laadt pas bij selectie
    preloadGallery();

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setGalleryIndex((galleryIndex - 1 + galleryImages.length) % galleryImages.length);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setGalleryIndex((galleryIndex + 1) % galleryImages.length);
      });
    }

    // Click main image to open lightbox
    var galleryMain = document.getElementById('nl-gallery-main');
    if (galleryMain) {
      galleryMain.addEventListener('click', function (e) {
        // Don't open lightbox if clicking nav buttons or badges
        if (e.target.closest('.nl-gallery__nav') || e.target.closest('.nl-gallery__badge')) return;
        // Video: klik speelt of pauzeert, geen lightbox
        var current = galleryImages[galleryIndex];
        if (current && current.type === 'video') {
          var vid = currentVideo();
          if (vid) { if (vid.paused) vid.play(); else vid.pause(); }
          return;
        }
        openLightbox(galleryIndex);
      });
      galleryMain.style.cursor = 'zoom-in';
    }

    // Touch swipe on main image
    var touchStartX = 0;
    var touchStartY = 0;
    if (galleryMain) {
      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      galleryMain.addEventListener('touchend', function (e) {
        var dx = touchStartX - e.changedTouches[0].screenX;
        var dy = touchStartY - e.changedTouches[0].screenY;
        // Only swipe if horizontal movement > vertical (not a scroll)
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          if (dx > 0) {
            setGalleryIndex((galleryIndex + 1) % galleryImages.length);
          } else {
            setGalleryIndex((galleryIndex - 1 + galleryImages.length) % galleryImages.length);
          }
        }
      }, { passive: true });
    }
  }

  function registreerThumb(thumb, i) {
    var src = thumb.getAttribute('data-src');
    galleryImages.push({
      src: src,
      alt: thumb.getAttribute('data-alt'),
      type: thumb.getAttribute('data-type') === 'video' ? 'video' : 'image',
      srcLarge: src.replace(/width=\d+/, 'width=1600')
    });

    thumb.addEventListener('click', function () {
      setGalleryIndex(i);
    });
  }

  function preloadGallery() {
    galleryImages.forEach(function (img) {
      if (img.type !== 'video') preloadImage(img.src);
    });
  }

  /* ============================
     FOTO'S PER VARIANT
     Alleen actief als de sectie #nl-variant-fotos in de pagina zet, en dat
     gebeurt alleen als minstens een variant foto's heeft in custom.variant_fotos.
     Alle reeksen staan in die JSON: een wissel doet geen extra verzoek.
     ============================ */

  var fotoData = null;
  var fotoSetHuidig = 'standaard';

  function initVariantFotos() {
    var el = document.getElementById('nl-variant-fotos');
    if (!el) return;
    try {
      fotoData = JSON.parse(el.textContent);
    } catch (e) {
      fotoData = null;
      return;
    }
    if (!fotoData || !fotoData.standaard || !fotoData.varianten) {
      fotoData = null;
      return;
    }
    fotoSetHuidig = String(fotoData.actief || 'standaard');
  }

  function fotoLabel(sleutel, waarde) {
    var labels = (fotoData && fotoData.labels) || {};
    return String(labels[sleutel] || '').replace('[n]', waarde).replace('[v]', waarde);
  }

  var PLAY_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="8 5 19 12 8 19"/></svg>';

  function bouwThumbs(set) {
    var wrap = document.getElementById('nl-gallery-thumbs');
    if (!wrap) return;
    while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
    galleryImages = [];

    (set.items || []).forEach(function (item, i) {
      var isVideo = item.type === 'video';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nl-gallery__thumb' +
        (i === 0 ? ' nl-gallery__thumb--active' : '') +
        (isVideo ? ' nl-gallery__thumb--video' : '');
      btn.setAttribute('data-index', i);
      btn.setAttribute('data-type', isVideo ? 'video' : 'image');
      btn.setAttribute('data-src', item.src);
      btn.setAttribute('data-alt', item.alt || '');
      btn.setAttribute('aria-label', fotoLabel(isVideo ? 'video' : 'foto', i + 1));

      var img = document.createElement('img');
      img.src = item.thumb;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 68;
      img.height = 68;
      btn.appendChild(img);

      if (isVideo) {
        var play = document.createElement('span');
        play.className = 'nl-gallery__thumb-play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = PLAY_SVG;
        btn.appendChild(play);
      }

      wrap.appendChild(btn);
      registreerThumb(btn, i);
    });

    var totaal = parseInt(set.totaal, 10) || 0;
    var getoond = (set.items || []).length;
    if (totaal > getoond) {
      var meer = document.createElement('span');
      meer.className = 'nl-gallery__thumb-more';
      meer.textContent = '+' + (totaal - getoond);
      wrap.appendChild(meer);
    }
  }

  /**
   * Zet de fotoreeks van deze variant in de galerij. Geeft true terug als de
   * galerij hiermee klaar is; false betekent dat het oude gedrag geldt (de
   * variantafbeelding als grote foto). Zonder #nl-variant-fotos altijd false.
   */
  function wisselFotoset(variantId, variantTitel, variantImage) {
    if (!fotoData) return false;
    var doel = fotoData.varianten[String(variantId)] ? String(variantId) : 'standaard';

    if (doel === fotoSetHuidig) return doel !== 'standaard';

    var set = doel === 'standaard' ? fotoData.standaard : fotoData.varianten[doel];
    stopGalleryVideos();
    bouwThumbs(set);
    fotoSetHuidig = doel;

    var status = document.getElementById('nl-gallery-status');
    if (status) {
      status.textContent = doel === 'standaard'
        ? fotoLabel('standaard', '')
        : fotoLabel('variant', variantTitel || '');
    }

    var start = 0;
    var direct = false;
    if (doel === 'standaard' && variantImage) {
      // Terug naar de gewone reeks: begin bij de variantafbeelding, net als voorheen
      // Vergelijken op het pad: image_url op een afbeelding en op een media-item
      // geven hetzelfde bestand, maar niet altijd dezelfde querystring.
      var pad = function (u) { return String(u || '').split('?')[0]; };
      start = -1;
      galleryImages.forEach(function (img, i) {
        if (start === -1 && pad(img.src) === pad(variantImage)) start = i;
      });
      if (start === -1) {
        start = 0;
        direct = true;
      }
    }

    galleryIndex = -1;
    if (direct) {
      // Variantafbeelding staat niet in de eerste reeks: toon hem zoals het oude gedrag deed
      var mainImg = document.getElementById('nl-gallery-img');
      var galleryMain = document.getElementById('nl-gallery-main');
      galleryIndex = 0;
      if (mainImg) {
        mainImg.hidden = false;
        mainImg.src = variantImage;
      }
      if (galleryMain) {
        galleryMain.setAttribute('data-index', 0);
        galleryMain.style.cursor = 'zoom-in';
      }
    } else {
      setGalleryIndex(start);
    }
    preloadGallery();

    var gallery = document.getElementById('nl-gallery');
    if (gallery) {
      gallery.dispatchEvent(new CustomEvent('nlf:galerij-gewisseld', {
        bubbles: true,
        detail: { set: doel, aantal: galleryImages.length }
      }));
    }
    return true;
  }

  function currentVideo() {
    return document.querySelector('.nl-gallery__video[data-index="' + galleryIndex + '"]');
  }

  function stopGalleryVideos() {
    document.querySelectorAll('.nl-gallery__video').forEach(function (vid) {
      vid.pause();
      vid.hidden = true;
    });
  }

  function setGalleryIndex(idx) {
    var item = galleryImages[idx];
    if (idx === galleryIndex && item && item.type !== 'video' &&
        document.getElementById('nl-gallery-img').src.indexOf(item.src) !== -1) return;
    galleryIndex = idx;
    var mainImg = document.getElementById('nl-gallery-img');
    var galleryMain = document.getElementById('nl-gallery-main');

    if (item && item.type === 'video') {
      stopGalleryVideos();
      var vid = currentVideo();
      if (vid) {
        vid.hidden = false;
        if (mainImg) mainImg.hidden = true;
        if (galleryMain) {
          galleryMain.setAttribute('data-index', idx);
          galleryMain.style.cursor = 'pointer';
        }
        vid.muted = true;
        var playing = vid.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
      document.querySelectorAll('.nl-gallery__thumb').forEach(function (thumb, i) {
        thumb.classList.toggle('nl-gallery__thumb--active', i === idx);
      });
      return;
    }

    stopGalleryVideos();
    if (mainImg) mainImg.hidden = false;
    if (galleryMain) galleryMain.style.cursor = 'zoom-in';

    if (mainImg && galleryImages[idx]) {
      // Doel vastleggen: de reeks kan wisselen voordat het beeld geladen is
      var doelItem = galleryImages[idx];
      var verzoek = ++galleryLaadVerzoek;
      if (galleryMain) galleryMain.setAttribute('data-index', idx);
      // Fade out, swap, fade in
      mainImg.classList.add('nl-gallery__img--fading');
      preloadImage(doelItem.src).then(function () {
        if (galleryImages[idx] !== doelItem || galleryIndex !== idx) {
          // Verouderd verzoek: alleen de fade opheffen als er niets nieuwers laadt
          if (verzoek === galleryLaadVerzoek) mainImg.classList.remove('nl-gallery__img--fading');
          return;
        }
        mainImg.src = doelItem.src;
        mainImg.alt = doelItem.alt;
        // Force reflow then fade in
        void mainImg.offsetWidth;
        mainImg.classList.remove('nl-gallery__img--fading');
      });
    }

    document.querySelectorAll('.nl-gallery__thumb').forEach(function (thumb, i) {
      thumb.classList.toggle('nl-gallery__thumb--active', i === idx);
    });
  }

  /* ============================
     LIGHTBOX
     ============================ */

  var lightboxEl = null;
  var lightboxImg = null;
  var lightboxCounter = null;
  var lightboxIndex = 0;

  function createLightbox() {
    if (lightboxEl) return;

    lightboxEl = document.createElement('div');
    lightboxEl.className = 'nl-lightbox';
    lightboxEl.setAttribute('role', 'dialog');
    lightboxEl.setAttribute('aria-label', 'Foto vergroten');
    lightboxEl.innerHTML =
      '<button type="button" class="nl-lightbox__close" aria-label="Sluiten">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<button type="button" class="nl-lightbox__nav nl-lightbox__nav--prev" aria-label="Vorige foto">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<button type="button" class="nl-lightbox__nav nl-lightbox__nav--next" aria-label="Volgende foto">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>' +
      '<div class="nl-lightbox__img-wrap">' +
        '<img class="nl-lightbox__img" src="" alt="">' +
      '</div>' +
      '<div class="nl-lightbox__counter"></div>';

    document.body.appendChild(lightboxEl);

    lightboxImg = lightboxEl.querySelector('.nl-lightbox__img');
    lightboxCounter = lightboxEl.querySelector('.nl-lightbox__counter');

    // Close button
    lightboxEl.querySelector('.nl-lightbox__close').addEventListener('click', closeLightbox);

    // Click backdrop to close
    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl || e.target.classList.contains('nl-lightbox__img-wrap')) {
        closeLightbox();
      }
    });

    // Nav buttons
    lightboxEl.querySelector('.nl-lightbox__nav--prev').addEventListener('click', function () {
      lightboxNavigate(-1);
    });
    lightboxEl.querySelector('.nl-lightbox__nav--next').addEventListener('click', function () {
      lightboxNavigate(1);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (!lightboxEl || !lightboxEl.classList.contains('nl-lightbox--open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxNavigate(-1);
      if (e.key === 'ArrowRight') lightboxNavigate(1);
    });

    // Touch swipe in lightbox
    var lbTouchStartX = 0;
    lightboxEl.addEventListener('touchstart', function (e) {
      lbTouchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lightboxEl.addEventListener('touchend', function (e) {
      var diff = lbTouchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 60) {
        lightboxNavigate(diff > 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  function openLightbox(idx) {
    // Video vergroten heeft geen zin, die speelt in de gallerij zelf
    if (galleryImages[idx] && galleryImages[idx].type === 'video') return;
    createLightbox();
    lightboxIndex = idx;
    updateLightboxImage();
    lightboxEl.classList.add('nl-lightbox--open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('nl-lightbox--open');
    document.body.style.overflow = '';
  }

  function lightboxNavigate(dir) {
    // Sla video's over: de lightbox toont alleen foto's
    for (var step = 0; step < galleryImages.length; step++) {
      lightboxIndex = (lightboxIndex + dir + galleryImages.length) % galleryImages.length;
      if (!galleryImages[lightboxIndex] || galleryImages[lightboxIndex].type !== 'video') break;
    }
    updateLightboxImage();
  }

  function updateLightboxImage() {
    if (!lightboxImg || !galleryImages[lightboxIndex]) return;
    var img = galleryImages[lightboxIndex];
    // Use large version for lightbox
    var largeSrc = img.srcLarge || img.src;
    lightboxImg.classList.add('nl-lightbox__img--loading');
    preloadImage(largeSrc).then(function () {
      lightboxImg.src = largeSrc;
      lightboxImg.alt = img.alt;
      lightboxImg.classList.remove('nl-lightbox__img--loading');
    });
    if (lightboxCounter) {
      var photos = galleryImages.filter(function (item) { return item.type !== 'video'; });
      lightboxCounter.textContent = (photos.indexOf(img) + 1) + ' / ' + photos.length;
    }
    // Also sync main gallery
    setGalleryIndex(lightboxIndex);
  }

  /* ============================
     VARIANT SWITCHING
     ============================ */

  function initVariantSelector() {
    var buttons = document.querySelectorAll('.nl-variant-btn');
    if (buttons.length === 0) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.hasAttribute('disabled')) return;

        // Update active state
        buttons.forEach(function (b) {
          b.classList.remove('nl-variant-btn--active');
        });
        this.classList.add('nl-variant-btn--active');

        var variantId = this.getAttribute('data-variant-id');
        var variantPrice = parseInt(this.getAttribute('data-variant-price'), 10);
        var variantCompare = parseInt(this.getAttribute('data-variant-compare'), 10);
        var variantAvailable = this.getAttribute('data-variant-available') === 'true';
        var variantInventory = parseInt(this.getAttribute('data-variant-inventory'), 10);
        var variantImage = this.getAttribute('data-variant-image');
        var variantEx = this.getAttribute('data-variant-ex');

        // Update hidden input
        var idInput = document.getElementById('nl-variant-id');
        if (idInput) idInput.value = variantId;

        // Update displayed price
        var priceEl = document.getElementById('nl-selected-price');
        if (priceEl) priceEl.textContent = formatMoney(variantPrice);

        // Zakelijke stand: het bedrag zonder btw hoort mee te gaan. Het komt
        // kant-en-klaar uit het data-attribuut, zodat de omrekening alleen in
        // snippets/nlf-ex-btw.liquid staat.
        var exEl = document.getElementById('nl-ex-price');
        if (exEl && variantEx) exEl.textContent = variantEx;

        // Update compare price & discount badge
        var compareEl = document.getElementById('nl-compare-price');
        var discountEl = document.getElementById('nl-discount-badge');
        if (variantCompare && variantCompare > variantPrice) {
          var pct = Math.round(((variantCompare - variantPrice) / variantCompare) * 100);
          if (compareEl) {
            compareEl.textContent = formatMoney(variantCompare);
            compareEl.style.display = '';
          }
          if (discountEl) {
            discountEl.textContent = '-' + pct + '%';
            discountEl.style.display = '';
          }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
        }

        // Update stock indicator
        var stockDot = document.getElementById('nl-stock-dot');
        var stockText = document.getElementById('nl-stock-text');
        var stockUrgency = document.getElementById('nl-stock-urgency');
        var ctaBtn = document.getElementById('nl-cta-btn');
        var ctaText = document.getElementById('nl-cta-text');

        if (variantAvailable) {
          if (stockDot) stockDot.style.background = '';
          if (stockText) {
            stockText.textContent = 'Op voorraad';
            stockText.classList.remove('nl-stock-text--oos');
          }
          if (stockUrgency) {
            if (variantInventory > 0 && variantInventory <= 5) {
              stockUrgency.textContent = 'Nog ' + variantInventory;
              stockUrgency.style.display = '';
            } else {
              stockUrgency.style.display = 'none';
            }
          }
          if (ctaBtn) {
            ctaBtn.disabled = false;
            ctaBtn.classList.remove('nl-cta-btn--disabled');
          }
          if (ctaText) ctaText.textContent = 'In winkelwagen';
        } else {
          if (stockDot) stockDot.style.background = 'var(--err)';
          if (stockText) {
            stockText.textContent = 'Uitverkocht';
            stockText.classList.add('nl-stock-text--oos');
          }
          if (stockUrgency) stockUrgency.style.display = 'none';
          if (ctaBtn) {
            ctaBtn.disabled = true;
            ctaBtn.classList.add('nl-cta-btn--disabled');
          }
          if (ctaText) ctaText.textContent = 'Uitverkocht';
        }

        // Update URL without reload
        var url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);

        // Update sticky bar price
        var stickyPrice = document.getElementById('nl-sticky-price');
        if (stickyPrice) stickyPrice.textContent = formatMoney(variantPrice);

        // Eigen fotoreeks van de variant (custom.variant_fotos), anders zoals altijd
        var eigenReeks = wisselFotoset(variantId, this.getAttribute('data-variant-title'), variantImage);

        // Switch gallery image if variant has one
        if (!eigenReeks && variantImage) {
          var mainImg = document.getElementById('nl-gallery-img');
          if (mainImg) {
            // Speelt er een video, zet die eerst weg
            stopGalleryVideos();
            mainImg.hidden = false;
            mainImg.src = variantImage;
          }
        }

        // Voor andere scripts op de pagina: welke variant er nu gekozen is
        document.dispatchEvent(new CustomEvent('nlf:variant-change', {
          detail: { variantId: variantId, eigenFotoreeks: eigenReeks }
        }));
      });
    });
  }

  /* ============================
     AJAX ADD TO CART
     ============================ */

  function initAddToCart() {
    var form = document.getElementById('nl-add-to-cart-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = document.getElementById('nl-cta-btn');
      var btnText = document.getElementById('nl-cta-text');
      if (!btn || btn.disabled) return;

      var variantId = document.getElementById('nl-variant-id').value;
      var bundleCheckbox = document.getElementById('nl-bundle-checkbox');
      var addBundle = bundleCheckbox && bundleCheckbox.checked;

      // Disable button during request
      btn.disabled = true;

      var addMain = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });

      addMain
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          if (addBundle) {
            var bundleId = bundleCheckbox.getAttribute('data-variant-id');
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(bundleId, 10), quantity: 1 })
            });
          }
        })
        .then(function () {
          // Redirect to cart page
          window.location = nlfCartUrl();
        })
        .catch(function (err) {
          console.error('Cart error:', err);
          btn.disabled = false;
          if (btnText) btnText.textContent = 'In winkelwagen';
        });
    });
  }

  /* ============================
     BUNDLE CHECKBOX STYLING
     ============================ */

  function initBundle() {
    var checkbox = document.getElementById('nl-bundle-checkbox');
    var label = document.getElementById('nl-bundle');
    if (!checkbox || !label) return;

    checkbox.addEventListener('change', function () {
      label.classList.toggle('nl-bundle--checked', this.checked);
    });
  }

  /* ============================
     COLLAPSIBLE SECTIONS
     ============================ */

  function initCollapsibles() {
    document.querySelectorAll('.nl-collapsible__trigger').forEach(function (trigger) {
      // Skip FAQ trigger (handled separately)
      if (trigger.id === 'nl-faq-trigger') return;

      trigger.addEventListener('click', function () {
        var parent = this.closest('.nl-collapsible');
        if (!parent) return;
        var isOpen = parent.classList.contains('nl-collapsible--open');
        parent.classList.toggle('nl-collapsible--open');
        this.setAttribute('aria-expanded', !isOpen);
      });
    });

    // FAQ trigger
    var faqTrigger = document.getElementById('nl-faq-trigger');
    if (faqTrigger) {
      faqTrigger.addEventListener('click', function () {
        var parent = this.closest('.nl-collapsible');
        if (!parent) return;
        var content = parent.querySelector('.nl-collapsible__content');
        var isOpen = content.style.maxHeight !== '0px' && content.style.maxHeight !== '';

        if (isOpen) {
          content.style.maxHeight = '0px';
          parent.classList.remove('nl-collapsible--open');
          this.setAttribute('aria-expanded', 'false');
        } else {
          content.style.maxHeight = '4000px';
          parent.classList.add('nl-collapsible--open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  /* ============================
     FAQ ACCORDION
     ============================ */

  function initFAQ() {
    var faqList = document.getElementById('nl-faq-list');
    if (!faqList) return;

    faqList.addEventListener('click', function (e) {
      var questionBtn = e.target.closest('.nl-faq-item__question');
      if (!questionBtn) return;

      var item = questionBtn.closest('.nl-faq-item');
      if (!item) return;

      var isOpen = item.classList.contains('nl-faq-item--open');

      // Close all
      faqList.querySelectorAll('.nl-faq-item').forEach(function (faq) {
        faq.classList.remove('nl-faq-item--open');
        var answer = faq.querySelector('.nl-faq-item__answer');
        if (answer) answer.style.maxHeight = '0px';
        var btn = faq.querySelector('.nl-faq-item__question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      // Toggle clicked
      if (!isOpen) {
        item.classList.add('nl-faq-item--open');
        var answer = item.querySelector('.nl-faq-item__answer');
        if (answer) answer.style.maxHeight = '500px';
        questionBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ============================
     STICKY MOBILE CTA
     ============================ */

  function initStickyBar() {
    var stickyBar = document.getElementById('nl-sticky-bar');
    var stickyBtn = document.getElementById('nl-sticky-btn');
    var form = document.getElementById('nl-add-to-cart-form');
    var ctaBtn = document.getElementById('nl-cta-btn');

    if (!stickyBar) return;

    // Use CTA button as trigger, show sticky bar when CTA scrolls out of view
    var triggerEl = ctaBtn || form;
    var lastShow = false;

    function onScroll() {
      var show = false;
      if (triggerEl) {
        var rect = triggerEl.getBoundingClientRect();
        // Show when CTA button is above the viewport (scrolled past it)
        show = rect.bottom < 0;
      } else {
        show = window.scrollY > 500;
      }

      // Hide when footer is visible
      if (show) {
        var footer = document.querySelector('.nlf-footer');
        if (footer) {
          var footerTop = footer.getBoundingClientRect().top;
          if (footerTop < window.innerHeight) show = false;
        }
      }

      if (show !== lastShow) {
        lastShow = show;
        if (show) {
          stickyBar.classList.add('nl-sticky-bar--visible');
        } else {
          stickyBar.classList.remove('nl-sticky-bar--visible');
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Sticky button dispatches form submit
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ============================
     CROSS-SELL (Recommendations API)
     ============================ */

  function initCrossSell() {
    var section = document.getElementById('nl-crosssell-section');
    var grid = document.getElementById('nl-crosssell-grid');
    if (!section || !grid) return;

    var productId = section.getAttribute('data-product-id');
    if (!productId) return;

    fetch(((window.routes && window.routes.product_recommendations_url) || '/recommendations/products.json')
      + '?product_id=' + productId + '&limit=6&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          section.style.display = 'none';
          return;
        }

        data.products.forEach(function (p) {
          var card = document.createElement('a');
          card.href = p.url;
          card.className = 'nl-crosssell-card';

          // Zelfde beeldkeuze als de collectiekaarten: sfeerfoto (images[1]) boven catalogusfoto
          var imgs = p.images || [];
          var raw = imgs.length > 1 ? imgs[1] : (imgs[0] || p.featured_image || '');
          var imgSrc = '';
          if (raw) {
            imgSrc = (typeof raw === 'string' ? raw : raw.url || raw.src || '');
            imgSrc = imgSrc.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
            imgSrc += (imgSrc.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          }

          card.innerHTML =
            '<div class="nl-crosssell-card__img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400">' : '') +
              '<span class="nl-crosssell-card__go" aria-hidden="true">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>' +
              '</span>' +
            '</div>' +
            '<div class="nl-crosssell-card__info">' +
              '<div class="nl-crosssell-card__title">' + (p.title || '') + '</div>' +
              '<div class="nl-crosssell-card__price">' + formatMoney(p.price) + '</div>' +
            '</div>';

          grid.appendChild(card);
        });

        if (grid.children.length > 0) {
          section.style.display = '';
        }
      })
      .catch(function (err) {
        console.error('Cross-sell load error:', err);
        section.style.display = 'none';
      });
  }

  /* ============================
     INIT ON DOM READY
     ============================ */

  function init() {
    initVariantFotos();
    initGallery();
    initVariantSelector();
    initAddToCart();
    initBundle();
    initCollapsibles();
    initFAQ();
    initStickyBar();
    initCrossSell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
